import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"
import _ from 'underscore'

export default {
  getDefaultProps() {
    return {maxObjectNameLength: 75};
  },

  favorite(e) {
    e.preventDefault();
    if (this.props.favoriteToggled) {
      this.props.favoriteToggled(this.props.accommodation, ReactDOM.findDOMNode(this));
    }

    const self = this;

    if (this.props.accommodation.sign_up_path) { window.location.replace(self.props.accommodation.favorite_path); }

    return $.ajax({
      url: self.props.accommodation.favorite_path,
      dataType: 'json',
      success(data) {
        return $(ReactDOM.findDOMNode(self)).find('.favorite-icon').toggleClass('favorite-active');
      }
    });
  },

  object_name(name) {
    if (name.length > this.props.maxObjectNameLength) {
      name = name.substring(0, this.props.maxObjectNameLength) + '...';
    }

    return name;
  },

  isLastMinute() {
    const price = this.priceObject();
    if (_.isObject(price)) { return price.last_minute; }
  },

  priceObject() {
    return this.props.price || this.props.accommodation.price;
  },

  object_rating() {
    const { rating } = this.props;

    if (_.isNumber(rating)) {
      return <div className="rating rating--bt rating--highlight" itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
          <meta itemProp="reviewCount" content={this.props.accommodation.recension_count} />
          <div className="rating__count">{I18n.t('search.recension', { count: this.props.accommodation.recension_count })}</div>
          <div className="rating__average review-rating" itemProp="ratingValue">{rating}</div>
        </div>;
    } else {
      return <div className="rating rating--bt empty">
          <div className="rating__count">&nbsp;</div>
        </div>;
    }
  },

  object_price() {
    const price = this.priceObject();

    if (!_.isObject(price)) {
      return <div className="price price--loading"></div>;
    }

    if (!price.price_for_period && (price.last_minute === false)) {
      return <div className="price price--accomodation">
          <div className="price__amount price__amount--unknown">
            {I18n.t('adverts.javascript.price_on_request')}
          </div>
        </div>;
    } else {
      let per;
      if (this.props.accommodation.type === 'bed_and_breakfasts') {
        per = I18n.t('search.price_per_day');
      } else {
        per = (price.fluctuating != null) ? I18n.t('search.price_per_week_from') : I18n.t('search.price_per_week');
      }

      const price_for_period = (() => {
        if (price.price_for_period) {

        return <div className={price.last_minute ? 'price__old' : 'price__amount'}>
          {price.price_for_period}
          </div>;
      }
      })();

      if (price.last_minute) {
        const wrapper_classes = ['price__amount'];
        if (price.price_for_period === null) { wrapper_classes.push('only-last-minute'); }
        const lm_text = <div className={wrapper_classes.join(' ')}>{price.last_minute_price}</div>;
        const lm_date = <div className="price__period">{price.from} - {price.to}</div>;

        return <div className="price price--accomodation price--last-minute">
            {lm_date}
            {price_for_period}
            {lm_text}
            <div className="price__label">{per}</div>
          </div>;
      } else {
        return <div className="price price--accomodation">
          {price_for_period}
          <div className="price__label">{per}</div>
          </div>;
      }
    }
  },

  fetchPricingInformation() {
    return $.ajax({
      url: this.props.accommodation.price_path,
      data: { id: this.props.accommodation.id },
      dataType: 'json'
    });
  }
};
